import { fetchAsObservable } from "fetcher!sofe";
import { pluck } from "rxjs/operators";

export function getReport(clients, engagements, version, revision, name) {
  return fetchAsObservable(
    `/clients/${clients}/engagements/${engagements}/versions/${version}-${revision}/reports/${name}`
  ).pipe(pluck("reports"));
}
